import { Dimension } from '@supermeme-ai/types'
import { isDesktop } from 'react-device-detect'

export const getBottomTextY = (
  bottomText: string,
  imageDimensions: Dimension,
  fontSize: number,
  topBottomTextPadding: number
) => {
  const imageWidthToTextLengthRatio = imageDimensions.width / bottomText.length
  const baseHeight = imageDimensions.height - topBottomTextPadding * 2

  if (imageWidthToTextLengthRatio > 12.5) {
    return baseHeight - fontSize * 1.5
  } else if (imageWidthToTextLengthRatio > 8) {
    return baseHeight - fontSize * 3
  } else if (imageWidthToTextLengthRatio > 6) {
    return baseHeight - fontSize * 4
  } else {
    return baseHeight - fontSize * 5
  }
}
